export default __webpack_public_path__ + "94e679a8682242144e7b08e7f38422b5.svg";